import { makeNetworkRequest } from "../utils/networkUtils";
import { getObjectValue } from "../utils/utils";
import Site from "./Site";

export default class User {

    defaultProfile = {
        username: '',
        firstName: '',
        lastName: '',
        company: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        locations: '',
        labeledData: '',
        isAdmin: false
    };

    defaultProfileErrors = {
        usernameError: '',
        firstNameError: '',
        lastNameError: '',
        companyError: '',
        address1Error: '',
        address2Error: '',
        cityError: '',
        stateError: '',
        zipError: '',
        locationsError: '',
        labeledDataError: ''
    };

    defaultLocation = {
        nickname: '',
        lat: '',
        lon: '',
        status: 'active'
    };

    constructor(auth0Profile) {
        this.prepopulateProfile();
        this.firstName = auth0Profile.given_name;
        this.lastName = auth0Profile.family_name;
        this.sub = auth0Profile.user_id ? auth0Profile.user_id : auth0Profile.sub;
        this.email = auth0Profile.email;
        this.accessToken = auth0Profile.accessToken;
        if(getObjectValue(auth0Profile, "user_metadata")) {
            this.username = auth0Profile.user_metadata.username;
            this.firstName = auth0Profile.user_metadata.firstName ? auth0Profile.user_metadata.firstName : this.firstName;
            this.lastName = auth0Profile.user_metadata.lastName ? auth0Profile.user_metadata.lastName : this.lastName;
            this.company = auth0Profile.user_metadata.company;
            this.address1 = auth0Profile.user_metadata.address1;
            this.address2 = auth0Profile.user_metadata.address2;
            this.city = auth0Profile.user_metadata.city;
            this.state = auth0Profile.user_metadata.state;
            this.zip = auth0Profile.user_metadata.zip;
            if(getObjectValue(auth0Profile.user_metadata, "locations")) {
                let newLocations = {}
                Object.keys(auth0Profile.user_metadata.locations).forEach((nestedKey) => {
                    let newLocationsName = nestedKey.replaceAll(":", ".");
                    let newLocation = { [newLocationsName]: { ...auth0Profile.user_metadata.locations[nestedKey] } };
                    Object.assign(newLocations, { ...newLocation }); 
                });
                this.locations = newLocations;
            } else {
                this.locations = '';
            }
            this.labeledData = auth0Profile.user_metadata.labeledData ? auth0Profile.user_metadata.labeledData : {};
        }
    };

    prepopulateProfile = () => {
        Object.keys(this.defaultProfile).forEach((key) => {
            this[key] = this.defaultProfile[key];
        });
    };

    getSites = async () => {
        if(this.sub && this.accessToken) {
            let accessControls = await makeNetworkRequest("get", "/sites", this.accessToken, {});
            // console.log(accessControls);

            if(accessControls) {
                let buckets = accessControls.buckets;
                this.isAdmin = accessControls.isAdmin;
                this.sites = Object.keys(buckets).map((resource_id) => {
                    let resource = buckets[resource_id];
                    let permissions = resource.permissions;
                    let status = resource.status;
                    let owner = resource.owner;
                    return new Site("", permissions, status, owner, resource_id);
                });
            }
        }
    };

    checkSitesForSelectedSite = async (siteToLookFor, setSelectedSite) => {
        let wasFound = false;
        await Promise.all(this.sites.map((s) => {
            if(s.slug === siteToLookFor) {
                wasFound = true;
                setSelectedSite(s);
            }
            return true;
        }));
        return wasFound;
    };
};
